export class SourceAwsOrganizationalUnit {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerOrganizationalUnitId",
            "baseName": "providerOrganizationalUnitId",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerManagementAccountId",
            "baseName": "providerManagementAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "AccountState",
            "format": ""
        },
        {
            "name": "accountCount",
            "baseName": "accountCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "selectedAccountIds",
            "baseName": "selectedAccountIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "selectiveOnboarding",
            "baseName": "selectiveOnboarding",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAwsOrganizationalUnit.attributeTypeMap;
    }
    constructor() {
    }
}
